import axios from '@/plugins/axios';
import qs from 'qs';

export function getContacts(query = {}, config) {
    const queryString = qs.stringify(query);
    return axios.get('/contacts?' + queryString, config);
}